import PropTypes from 'prop-types';
import React from 'react';
import getData from './getData';

/**
 *  Product Schema Component
 *
 */
function Product(_ref) {
  let {
    inventory,
    derivedprice,
    rating,
    url,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("script", Object.assign({
    "data-cmp": "vehicleProductSchema",
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `${JSON.stringify(getData(inventory, derivedprice, rating, url))}`
    }
  }, rest));
}
export default Product;